var nunjucks = require("nunjucks/browser/nunjucks-slim");
var env;
if (!nunjucks.currentEnv){
	env = nunjucks.currentEnv = new nunjucks.Environment([], undefined);
} else {
	env = nunjucks.currentEnv;
}
var configure = require("../../../../../../nunjucks.config.js")(env);
var dependencies = nunjucks.webpackDependencies || (nunjucks.webpackDependencies = {});
dependencies["front/utils/macros.jinja"] = require( "front/utils/macros.jinja" );




var shim = require("/var/www/django/bangbangstudio.ru/application/node_modules/nunjucks-loader/runtime-shim");


(function() {(nunjucks.nunjucksPrecompiled = nunjucks.nunjucksPrecompiled || {})["assets/app/front/components/IndexComponents/Storyboards/Storyboards.jinja"] = (function() {
function root(env, context, frame, runtime, cb) {
var lineno = 0;
var colno = 0;
var output = "";
try {
var parentTemplate = null;
env.getTemplate("front/utils/macros.jinja", false, "assets/app/front/components/IndexComponents/Storyboards/Storyboards.jinja", false, function(t_2,t_1) {
if(t_2) { cb(t_2); return; }
t_1.getExported(function(t_3,t_1) {
if(t_3) { cb(t_3); return; }
context.setVariable("macros", t_1);
output += "\n\n";
var macro_t_4 = runtime.makeMacro(
[], 
["storyboards"], 
function (kwargs) {
var callerFrame = frame;
frame = new runtime.Frame();
kwargs = kwargs || {};
if (Object.prototype.hasOwnProperty.call(kwargs, "caller")) {
frame.set("caller", kwargs.caller); }
frame.set("storyboards", Object.prototype.hasOwnProperty.call(kwargs, "storyboards") ? kwargs["storyboards"] : {});var t_5 = "";t_5 += "\n    <section class=\"IndexStoryboards\" id=\"storyboards\">\n        <h1>";
t_5 += runtime.suppressValue((lineno = 4, colno = 16, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "_"), "_", context, ["Сториборды"])), env.opts.autoescape);
t_5 += "</h1>\n        <div class=\"swiper-container\">\n            ";
frame = frame.push();
var t_8 = runtime.contextOrFrameLookup(context, frame, "storyboards");
if(t_8) {t_8 = runtime.fromIterator(t_8);
var t_7 = t_8.length;
for(var t_6=0; t_6 < t_8.length; t_6++) {
var t_9 = t_8[t_6];
frame.set("storyboard", t_9);
frame.set("loop.index", t_6 + 1);
frame.set("loop.index0", t_6);
frame.set("loop.revindex", t_7 - t_6);
frame.set("loop.revindex0", t_7 - t_6 - 1);
frame.set("loop.first", t_6 === 0);
frame.set("loop.last", t_6 === t_7 - 1);
frame.set("loop.length", t_7);
t_5 += "\n                <div class=\"IndexStoryboards-wrapper swiper-wrapper\">\n                    ";
frame = frame.push();
var t_12 = (lineno = 8, colno = 49, runtime.callWrap(runtime.memberLookup((t_9),"get"), "storyboard[\"get\"]", context, ["items"]));
if(t_12) {t_12 = runtime.fromIterator(t_12);
var t_11 = t_12.length;
for(var t_10=0; t_10 < t_12.length; t_10++) {
var t_13 = t_12[t_10];
frame.set("item", t_13);
frame.set("loop.index", t_10 + 1);
frame.set("loop.index0", t_10);
frame.set("loop.revindex", t_11 - t_10);
frame.set("loop.revindex0", t_11 - t_10 - 1);
frame.set("loop.first", t_10 === 0);
frame.set("loop.last", t_10 === t_11 - 1);
frame.set("loop.length", t_11);
t_5 += "\n                        <a ";
if(runtime.memberLookup((t_13),"url")) {
t_5 += "href=\"";
t_5 += runtime.suppressValue(runtime.memberLookup((t_13),"url"), env.opts.autoescape);
t_5 += "\"";
;
}
t_5 += " target=\"_blank\"\n                           class=\"IndexStoryboards-item ";
if(runtime.memberLookup((t_13),"url")) {
t_5 += "link";
;
}
t_5 += " swiper-slide isHide\" data-scroll data-scroll-offset=\"60\">\n                            ";
t_5 += runtime.suppressValue((lineno = 11, colno = 50, runtime.callWrap(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "macros")),"image2x"), "macros[\"image2x\"]", context, [runtime.memberLookup((t_13),"image"),runtime.makeKeywordArgs({"caller": (function (){var macro_t_14 = runtime.makeMacro(
[], 
[], 
function (kwargs) {
var callerFrame = frame;
frame = frame.push(true);
kwargs = kwargs || {};
if (Object.prototype.hasOwnProperty.call(kwargs, "caller")) {
frame.set("caller", kwargs.caller); }
var t_15 = "";;
frame = frame.pop();
return new runtime.SafeString(t_15);
});
return macro_t_14;})()})])), env.opts.autoescape);
t_5 += "\n                        </a>\n                    ";
;
}
}
frame = frame.pop();
t_5 += "\n                </div>\n                ";
if(runtime.memberLookup((t_9),"caption")) {
t_5 += "\n                    <div class=\"IndexStoryboards-caption\">";
t_5 += runtime.suppressValue(env.getFilter("safe").call(context, runtime.memberLookup((t_9),"caption")), env.opts.autoescape);
t_5 += "</div>\n                ";
;
}
t_5 += "\n            ";
;
}
}
frame = frame.pop();
t_5 += "\n        </div>\n        <a class=\"IndexIllustrations-link isHide\" data-scroll data-scroll-offset=\"60\" href=\"";
t_5 += runtime.suppressValue((lineno = 20, colno = 98, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "url"), "url", context, ["front:storyboards"])), env.opts.autoescape);
t_5 += "\">";
t_5 += runtime.suppressValue((lineno = 20, colno = 128, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "_"), "_", context, ["Смотреть все"])), env.opts.autoescape);
t_5 += "</a>\n    </section>\n";
;
frame = callerFrame;
return new runtime.SafeString(t_5);
});
context.addExport("IndexStoryboards");
context.setVariable("IndexStoryboards", macro_t_4);
output += "\n";
if(parentTemplate) {
parentTemplate.rootRenderFunc(env, context, frame, runtime, cb);
} else {
cb(null, output);
}
})});
} catch (e) {
  cb(runtime.handleError(e, lineno, colno));
}
}
return {
root: root
};

})();
})();



module.exports = shim(nunjucks, env, nunjucks.nunjucksPrecompiled["assets/app/front/components/IndexComponents/Storyboards/Storyboards.jinja"] , dependencies)